/* Carry the current Binom visit into the full article. This is an internal
 * navigation, so it must never call the offer endpoint or a conversion pixel. */
(function () {
  'use strict';
  if (window.OdorCrushPreviewNavigation) return;
  window.OdorCrushPreviewNavigation = true;
  var pending = null;
  var trafficKey = /^(utm_.*|gclid|dclid|fbclid|msclkid|ttclid|wbraid|gbraid|preview_theme_id)$/;
  var query = new URLSearchParams(window.location.search);

  function tracker() { return window.OdorCrushTracking; }
  function articleUrl(link) {
    var url;
    try {
      url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return null;
    } catch (error) { return null; }
    query.forEach(function (value, key) {
      if (trafficKey.test(key)) url.searchParams.set(key, value);
    });
    var state = tracker();
    var id = state && state.getClickId();
    url.searchParams.delete('bcid');
    if (typeof id === 'string' && /^[A-Za-z0-9_-]{1,200}$/.test(id)) {
      url.searchParams.set('bcid', id);
    }
    return url.href;
  }
  function refresh(link) {
    var url = articleUrl(link);
    if (url) link.href = url;
    return url;
  }
  function refreshAll() {
    document.querySelectorAll('a[data-odor-crush-continue]').forEach(refresh);
    if (pending && (!tracker() || tracker().status !== 'loading')) pending();
  }
  function findLink(event) {
    return event.target && event.target.closest ? event.target.closest('a[data-odor-crush-continue]') : null;
  }
  ['pointerdown', 'focusin', 'contextmenu'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var link = findLink(event);
      if (link) refresh(link);
    }, true);
  });
  function handleClick(event) {
    var link = findLink(event);
    if (!link || event.defaultPrevented || event.button > 1 || !refresh(link)) return;
    if (!tracker() || tracker().status !== 'loading') return;
    event.preventDefault();
    if (pending) return;
    link.setAttribute('aria-busy', 'true');
    var newTab = link.target === '_blank' || event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1;
    var tab = null;
    if (newTab) {
      try {
        tab = window.open('about:blank', '_blank');
        if (tab) tab.opener = null;
      } catch (error) { tab = null; }
    }
    var done = false;
    var timer;
    function navigate() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      pending = null;
      link.removeAttribute('aria-busy');
      var url = refresh(link);
      if (!url) return;
      if (tab) {
        if (!tab.closed) tab.location.replace(url);
      } else {
        window.location.assign(url);
      }
    }
    pending = navigate;
    timer = setTimeout(navigate, 4000);
  }
  document.addEventListener('click', handleClick);
  document.addEventListener('auxclick', handleClick);
  new MutationObserver(refreshAll).observe(document.documentElement, {
    attributes: true, attributeFilter: ['data-binom-status']
  });
  window.addEventListener('pageshow', refreshAll);
  refreshAll();
})();
